import React from 'react';
import { assetPath } from '../../utils/school-ui-helpers';

const LazyLoadImage = React.memo(({ src, alt, ...props }: any) => {
  if (typeof src === "undefined") return null;
  return (
    <img
      src={assetPath(src)}
      alt={alt}
      loading="lazy"
      {...props} />
  )
})

export default LazyLoadImage;